import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface TermsState {
  intendedPath: string | null
}

const initialState: TermsState = {
  intendedPath: null
}

const termsSlice = createSlice({
  name: 'terms',
  initialState,
  reducers: {
    requireAcceptance(state, action: PayloadAction<{ intendedPath: string }>) {
      state.intendedPath = action.payload.intendedPath
    },
    clearIntent(state) {
      state.intendedPath = null
    }
  }
})

export const termsReducer = termsSlice.reducer
export const termsActions = termsSlice.actions
